import {IProjectItem} from "../../types/IProjectItem";
import {useStoryblokApi} from "@storyblok/react";
import ButtonGroup from "../partials/ButtonGroup";
import ProjectTechStack from "./partials/ProjectTechStack";
import ProjectDuration from "./partials/ProjectDuration";
import {useMemo} from "react";
import classNames from "classnames";
import LightboxScreenshot from "./partials/LightboxScreenshot";
import ProjectQuote from "./partials/ProjectQuote";
import ProjectGallery from "./partials/ProjectGallery";
import {richTextResolver} from "@storyblok/richtext";

export default function ProjectStyle1({item, year}: { item: IProjectItem, year: number|string }) {
    const { render } = richTextResolver()

    const buttons = <ButtonGroup buttons={item.content?.buttons ?? []}/>

    const hasImages = useMemo(() => {
        return item.content.images?.length > 0
    }, [item.content.images?.length]);


    return <section key={item.uuid} id={`year-${year}`} className={"py-5 project-style-1"}>
        <div className="mx-auto w-full" data-aos={'fade-in'}>

            <div className="sm:grid sm:grid-cols-5 lg:items-start gap-x-8 lg:gap-x-24">
                <div
                    className={classNames({"relative z-10 ": true, 'col-span-3': hasImages, 'col-span-5': !hasImages})}>
                    <div className="mx-auto max-w-prose text-base lg:max-w-none">
                        {item.content.category && <div className={'flex gap-2 mb-3'}>
                            {item.content.category?.map((category, index) => {
                                return <span key={index} className="bg-gray-100 text-gray-700 p-2 text-xs inline-block">{category}</span>
                            })}
                        </div>}
                        <h2 className="text-lg font-semibold text-secondary" data-aos={'fade-in'}>
                            <ProjectDuration item={item}/>
                        </h2>
                        <p className="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl" >
                            {item.content.title}
                        </p>
                    </div>
                    <div className="relative z-10 mx-auto max-w-prose text-base lg:mx-0 lg:max-w-5xl">
                        <p className="text-lg text-gray-500">
                            {item.content.subtitle}
                        </p>
                    </div>

                    <div className="prose prose-secondary mx-auto text-gray-500 lg:max-w-none rich-text" >
                        <div className=""
                             dangerouslySetInnerHTML={{
                                 __html: render(item.content.description) as string
                             }}
                        >
                        </div>
                    </div>

                    {item.content?.buttons.length > 0 &&
                    <div className="mx-auto my-5 flex max-w-prose text-base lg:max-w-none gap-4">
                        {buttons}
                    </div>}

                    {item.content.images?.length > 2 &&
                    <div className="mx-auto my-5 flex max-w-prose text-base lg:max-w-none gap-4">
                        <ProjectGallery project={item}/>
                    </div>}
                </div>
                <div className={classNames({
                    "relative sm:mt-12 max-w-prose text-base lg:mt-0 lg:max-w-none": true,
                    'col-span-2  mx-auto ': hasImages,
                    'col-span-5': !hasImages
                })}>
                    {hasImages &&

                        <LightboxScreenshot screenshot={item.content.images?.[0]}
                                            projectTitle={item.content.title}/>}

                    <ProjectTechStack className={classNames({'mt-6': hasImages})} items={item.content.technologies}/>

                </div>
            </div>

            {item.content.show_client_testimonial &&
                <ProjectQuote item={item}/>}
        </div>
        <hr className={'my-12 border-t block'}/>
    </section>
}